/**This function remove final S, makes a word singular */
export const singularize = (word) => {
  const len = word.length;

  if(word[len - 1] === 's'){
    return word.slice(0, len -1)
  }

  return word
}